module.exports = __webpack_public_path__ + "img/login__background.724955f2.png";